let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kIryJ")).then(() => parcelRequire('j2TUq'));